export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  exec_times: number

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.exec_times = sumupGroup.exec_times;
  }
}

export class SumupUnitAll {
  total_examinee_count: number
  man_examinee_count: number
  woman_examinee_count: number
  total_avg_score: number
  man_avg_score: number
  woman_avg_score: number
  total_std_dev: number
  man_std_dev: number
  woman_std_dev: number
  total_min_score: number
  man_min_score: number
  woman_min_score: number
  total_max_score: number
  man_max_score: number
  woman_max_score: number
  allot: number

  constructor(x: any){
    this.total_examinee_count = x.total_examinee_count;
    this.man_examinee_count = x.man_examinee_count;
    this.woman_examinee_count = x.woman_examinee_count;
    this.total_avg_score = x.total_avg_score.toFixed(1);
    this.man_avg_score = x.man_avg_score.toFixed(1);
    this.woman_avg_score = x.woman_avg_score.toFixed(1);
    this.total_std_dev = x.total_std_dev.toFixed(1);
    this.man_std_dev = x.man_std_dev.toFixed(1);
    this.woman_std_dev = x.woman_std_dev.toFixed(1);
    this.total_min_score = x.total_min_score;
    this.man_min_score = x.man_min_score;
    this.woman_min_score = x.woman_min_score;
    this.total_max_score = x.total_max_score;
    this.man_max_score = x.man_max_score;
    this.woman_max_score = x.woman_max_score;
    this.allot = x.allot;
  }
}

export class SumupPart1All {
  part1: string
  question_content: string
  total_examinee_count: number
  man_examinee_count: number
  woman_examinee_count: number
  total_avg_score: number
  man_avg_score: number
  woman_avg_score: number
  total_score_rate: number
  man_score_rate: number
  woman_score_rate: number
  total_std_dev: number
  man_std_dev: number
  woman_std_dev: number
  total_min_score: number
  man_min_score: number
  woman_min_score: number
  total_max_score: number
  man_max_score: number
  woman_max_score: number
  allot: number

  constructor(x: any){
    this.part1 = x.part1;
    this.question_content = x.question_content;
    this.total_examinee_count = x.total_examinee_count;
    this.man_examinee_count = x.man_examinee_count;
    this.woman_examinee_count = x.woman_examinee_count;
    this.total_avg_score = x.total_avg_score.toFixed(1);
    this.man_avg_score = x.man_avg_score.toFixed(1);
    this.woman_avg_score = x.woman_avg_score.toFixed(1);
    this.total_score_rate = x.total_score_rate.toFixed(1);
    this.man_score_rate = x.man_score_rate.toFixed(1);
    this.woman_score_rate = x.woman_score_rate.toFixed(1);
    this.total_std_dev = x.total_std_dev.toFixed(1);
    this.man_std_dev = x.man_std_dev.toFixed(1);
    this.woman_std_dev = x.woman_std_dev.toFixed(1);
    this.total_min_score = x.total_min_score;
    this.man_min_score = x.man_min_score;
    this.woman_min_score = x.woman_min_score;
    this.total_max_score = x.total_max_score;
    this.man_max_score = x.man_max_score;
    this.woman_max_score = x.woman_max_score;
    this.allot = x.allot;
  }
}

export class SumupFieldAll {
  part1: string
  part2: string
  part3: string
  question_content: string
  allot: number
  total_score_rate: number
  man_score_rate: number
  woman_score_rate: number

  constructor(x: any){
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.question_content = x.question_content;
    this.allot = x.allot;
    this.total_score_rate = x.total_score_rate.toFixed(1);
    this.man_score_rate = x.man_score_rate.toFixed(1);
    this.woman_score_rate = x.woman_score_rate.toFixed(1);
  }
}